const REQUEST_STATUS_BG_COLOR = {
    APPROVED: 'success',
    REJECTED: 'danger',
    FAILED: 'danger',
    PENDING: '',
    EXPIRED: '',
};

const ROUTE_BY_USERTYPE = {
    NURSE: 'NurseProductCheckout',
    BASIC: 'BasicProductCheckout',
    DOCTOR: 'DoctorProductCheckout',
    ORG_OWNER: 'OrgOwnerProductCheckout',
};

export {
    REQUEST_STATUS_BG_COLOR,
    ROUTE_BY_USERTYPE,
};
